import React, { useEffect } from 'react';
import { ThemeProvider, Snackbar, Grow, Alert } from '@mui/material';
import { defaultTheme } from 'theme';
import {
  CheckCircleOutline,
  ErrorOutline,
  InfoOutlined,
  WarningAmberOutlined,
} from '@mui/icons-material';
import { useAppState } from 'components/contexts/State';

function SlideTransition(props) {
  return <Grow {...props} />;
}

function ToasterModal() {
  const themeWithType = {
    success: {
      background: 'rgba(237, 247, 237, 1)',
      border: '1px solid rgba(46, 125, 50, 0.5)',
      color: 'rgba(30, 70, 32, 1)',
    },
    error: {
      background: 'rgba(253, 237, 237, 1)',
      border: 'rgba(211, 47, 47, 0.5)',
      color: 'rgba(95, 33, 32, 1)',
    },
    info: {
      background: 'rgba(229, 246, 253, 1)',
      border: 'rgba(0, 84, 164, 0.5)',
      color: 'rgba(1, 67, 97, 1)',
    },
    warning: {
      background: 'rgba(255, 244, 229, 1)',
      border: 'rgba(239, 108, 0, 0.5)',
      color: 'rgba(102, 60, 0, 1)',
    },
  };
  const validTypes = ['success', 'info', 'warning', 'error'];

  const {
    isToasterMessageOpen,
    setIsToasterMessageOpen,
    toasterType,
    setToasterType,
    toasterMessage,
    setToasterMessage,
  } = useAppState();

  useEffect(() => {
    if (isToasterMessageOpen)
      setTimeout(() => {
        setIsToasterMessageOpen(false);
        setToasterType('');
        setToasterMessage('');
      }, [3000]);
  }, [isToasterMessageOpen]);

  return (
    <ThemeProvider theme={defaultTheme}>
      {validTypes.includes(toasterType) && (
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={isToasterMessageOpen}
          key={toasterMessage}
          TransitionComponent={SlideTransition}
          sx={{ zIndex: '99999' }}
        >
          <Alert
            severity={toasterType}
            iconMapping={{
              success: (
                <CheckCircleOutline
                  color='success'
                  sx={{ height: '22px', width: '22px' }}
                />
              ),
              error: (
                <ErrorOutline color='error' sx={{ height: '22px', width: '22px' }} />
              ),
              info: <InfoOutlined color='info' sx={{ height: '22px', width: '22px' }} />,
              warning: (
                <WarningAmberOutlined
                  color='warning'
                  sx={{ height: '22px', width: '22px' }}
                />
              ),
            }}
            sx={{
              padding: '6px 16px',
              fontSize: '16px',
              fontWeight: '500',
              lineHeight: '24px',
              letterSpacing: '0.15px',
              borderRadius: '4px',
              background: themeWithType[toasterType].background,
              color: themeWithType[toasterType].color,
              border: themeWithType[toasterType].border,
            }}
          >
            {toasterMessage}
          </Alert>
        </Snackbar>
      )}
    </ThemeProvider>
  );
}

export default ToasterModal;
